import React from 'react'
import * as yup from 'yup'

import { isResourceModelTest } from '@modules/resource/resource.module'

//Connects
import UseQuery from '@connects/query'
import UsePlural from '@connects/plural';

// Components
import Archive from '@components/Archive/Archive'

const configSchema = yup.object().shape({
	Model: yup.mixed().test(isResourceModelTest).required(),
	queryConfig: yup.object().default({}).required(),
	tableConfig: yup.object().required(),
	mapDataToCSV: yup.mixed(),
	filename: yup.string(),
})

export default function createArchiveContainer(config) {

	// validate config
	config = configSchema.validateSync(config)

	// set table filters default from queryConfig.filters
	if(undefined === config.tableConfig.filters && config.queryConfig.filters) {
		config.tableConfig.filters = config.queryConfig.filters;
	}

	// Create decorated container
	@UsePlural(config.Model.resourceKey)
	@UseQuery(config.queryConfig)
	class ArchiveContainer extends React.Component {

		// Lifecycle

		componentDidMount() {
			// TODO: remove hacky use of cleanedQuery (see UseQuery)
			this.props.actions.getMany(this.props.currentQuery)
		}

		componentDidUpdate(prevProps) {
			// fetch new data whenever query props are updated
			if(this.props.queryChanged(prevProps)) {
				this.props.actions.getMany(this.props.currentQuery);
			}
			window.scroll({
				top: 100,
				left: 100,
				behavior: 'smooth'
			  });
		}
		
		// Render 
				// title={config.title} 
				// resource={config.resource}
				// tableConfig={config.tableConfig}
				// mapDataToCSV={config.mapDataToCSV}
				// filename={config.filename}
		
		render() {
			return <Archive 
				{...config}
				{...this.props}
			/>
		}

	}

	return ArchiveContainer;

}


// WEBPACK FOOTER //
// ./src/components/Archive/createArchiveContainer.jsx